import type { Qty } from "./quantity.ts";

export const UNIT_CODES = ["pcs", "pair", "set", "l", "ml", "m", "cm", "kg", "g"] as const;
export type UnitCode = (typeof UNIT_CODES)[number];

/**
 * `decimals`: fraction digits users may enter. `step`: the −/+ stepper increment in milli-units.
 */
export const UNITS: Record<UnitCode, { decimals: number; step: Qty }> = {
  pcs: { decimals: 0, step: 1000 },
  pair: { decimals: 0, step: 1000 },
  set: { decimals: 0, step: 1000 },
  l: { decimals: 2, step: 1000 },
  ml: { decimals: 0, step: 100_000 },
  m: { decimals: 2, step: 1000 },
  cm: { decimals: 0, step: 10_000 },
  kg: { decimals: 3, step: 1000 },
  g: { decimals: 0, step: 100_000 },
};

export function isUnitCode(value: string): value is UnitCode {
  return (UNIT_CODES as readonly string[]).includes(value);
}
